import $ from "jquery";

$(() => {
  const modals = $(".download-modal-container");
  if (modals.length > 0) {
    modals.each((i, modal) => {
      const modalEl = $(modal);

      $(".open-download-modal").on("click", () => {
        modalEl.show();
      });
      modalEl.find(".close").on("click", () => {
        modalEl.hide();
      });
    });
  }
});
